import React from 'react';
import './App.css';

const ContactUsPage = () => {
  const contactMethods = [
    {
      img: "./images/email.jpg",
      title: "Email",
      desc: "Send us an email at wasalatours18@gmail.com and we'll respond within 24 hours.",
    },
    {
      img: "./images/what.jpg",
      title: "Phone",
      desc: "Call us at +94-719898789. We’re available from 9am to 6pm.",
    },
    {
      img: "./images/query.jpg",
      title: "Query",
      desc: "Use our Query feature on the website for instant support.",
    },
    {
      img: "./images/QR.jpeg",
      title: "QR Code",
      desc: "Use our QR Code and connect with us via WeChat.",
    },
  ];

  return (
    <div className="contact-header-container2">
      <div className="contact-subheading">
        <h2>How You Can Contact Us</h2>
      </div>

      <div className="contact-methods">
        {contactMethods.map((method, idx) => (
          <div key={idx} className="contact-method-card">
            <img src={method.img}  className="contact-method-image" />
            <h3>{method.title}</h3>
            {method.desc && <p>{method.desc}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactUsPage;
